// extracted by mini-css-extract-plugin
export default {"singleOptionWrapper":"lHaWVap","left":"ShJUXCA","right":"dq83fgm","optionDescription":"DrUaOmV"};